const { getProperty } = require('../PropertyGetter');

function filterOffersByColor(offers, colorBadgeIds) {
  if (!Array.isArray(offers) || !Array.isArray(colorBadgeIds)) {
    return offers;
  }

  return offers.filter(offer => offer.applicableToAllUpcs || colorBadgeIds.includes(offer.promoId));
}

function getActiveOffers(offers) {
  if (!Array.isArray(offers)) return [];

  return offers.filter(offer => offer.active);
}

function isApplicableWithOffer(topOffers, finalPrice) {
  const finalPriceOfferIds = finalPrice.applicablePromotions;

  if (!Array.isArray(topOffers) || !Array.isArray(finalPriceOfferIds)) {
    return false;
  }

  const topOfferIds = topOffers.map(offer => offer.promoId);

  return (
    topOfferIds.length >= finalPriceOfferIds.length &&

    topOfferIds.some(offerId => finalPriceOfferIds.includes(offerId))
  );
}

function getOffersData(offers, finalPrice, colorBadges, additionalData) {
  const activeOffers = getActiveOffers(offers);

  const withOffer = [];
  let withOfferPosition = 0;
  let filteredOffersByColor = activeOffers;

  if (
    getProperty(additionalData, 'featureEligible.colorwayOffers') &&
    colorBadges.length
  ) {
    filteredOffersByColor = filterOffersByColor(activeOffers, colorBadges);
  }

  const topOffers = filteredOffersByColor.slice(0, 2);
  if (
    finalPrice && !finalPrice.maskPromotion && topOffers.length &&
    isApplicableWithOffer(topOffers, finalPrice)
  ) {
    withOffer.push(finalPrice);
    withOfferPosition = 1;
  }

  const priceOffers = topOffers.slice(0, withOfferPosition);
  const regularOffers = topOffers.slice(withOfferPosition);

  // NOTE: This is mutating the object. This code should be temporary.
  getProperty(topOffers, '[0]', {}).firstActive = true;

  return {
    lists: {
      activeOffers,
      topOffers,
      priceOffers,
      withOffer,
      regularOffers,
    },
    isWithOffer: !!withOfferPosition,
    isMultipleOffers: topOffers.length > 1,
    displayMoreOffersLink: activeOffers.length > 2,
  };
}

module.exports = {
  getOffersData,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/Offers.js